// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QyPU","rootNoMargin":"styles_rootNoMargin__kPwZt"};